import { useApi } from '../hooks/useApi';
import { HelpTip } from '../components/HelpTip';
import { Skeleton } from '../components/Skeleton';

interface Resumen { totalFacturasPendientes: number; deudaFacturas: number; totalVencimientosPendientes: number; deudaVencimientos: number; totalDeuda: number; totalPagado: number; cajaFuturo: number; }

export function InformesPage() {
  const { data, loading } = useApi<Resumen>('/api/v3/resumen');

  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-bold text-slate-800 inline">Informes</h1><HelpTip tips={['Resumen financiero con indicadores clave del negocio','Deuda total = Facturas pendientes + Vencimientos','Total pagado = suma de todos los pagos registrados','Margen bruto se calcula como Ventas - Costo de ventas']} /><p className="text-slate-500 text-sm mt-1">Resumen financiero y operativo</p></div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { label:'Deuda Total', value:data?.totalDeuda??0, color:'bg-red-500' },
          { label:'Deuda Facturas', value:data?.deudaFacturas??0, color:'bg-orange-500' },
          { label:'Deuda Vencimientos', value:data?.deudaVencimientos??0, color:'bg-amber-500' },
          { label:'Total Pagado', value:data?.totalPagado??0, color:'bg-green-500' },
          { label:'Caja Futura', value:data?.cajaFuturo??0, color:'bg-blue-500' },
          { label:'Facturas Pend.', value:data?.totalFacturasPendientes??0, color:'bg-purple-500' },
          { label:'Venc. Pendientes', value:data?.totalVencimientosPendientes??0, color:'bg-indigo-500' },
          { label:'Balance', value:(data?.totalPagado??0)-(data?.totalDeuda??0), color:'bg-teal-500' },
        ].map(c=>(<div key={c.label} className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm">
          {loading ? (
            <>
              <Skeleton className="h-3 w-24 mb-2" />
              <Skeleton className="h-7 w-28" />
            </>
          ) : (
            <>
              <p className="text-xs text-slate-500 mb-1">{c.label}</p>
              <p className="text-2xl font-bold text-slate-800">${Number(c.value).toLocaleString('es-AR')}</p>
            </>
          )}
        </div>))}
      </div>
    </div>
  );
}
